// @ts-nocheck
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import {
  TrendingDown, TrendingUp,
} from "lucide-react";
import {
  DefinitionTooltip,
} from "src/components/common";
import {
  getOrganicContentKpiDefinitionInfo,
} from "../OrganicMediaDefinitions";
import { formatNumber } from "src/utils/numberFormat";
import { resolveDashboardChangePercent } from "src/utils/dashboardChangeFallback";
import {
  formatKpiTitle,
  getTrendState,
  withBidiIsolate,
  KPI_ICON_MAP,
} from "./InstagramContentHelpers";
import "../../../styles/InstagramContentReport/InstagramContentKpiCards.scss";

type InstagramContentKpiCard = {
  title: string;
  value: string;
  tooltipLabel?: string;
  percentageChange?: number | null;
  percentageChangeFormattedValue?: string | null;
  comparisonLabel?: string;
};

const InstagramContentKpiCards: FC<{ kpis: InstagramContentKpiCard[] }> = ({ kpis }) => {
  const { t, i18n } = useTranslation();
  return (
    <div className="organic-content-report__kpis" data-pdf-block="kpi-cards">
      {kpis.map((card, index) => {
        const kpiTrendPct = resolveDashboardChangePercent(
          card.percentageChange,
          `instagram-content-kpi-${index}-${card.title}`,
          { treatZeroAsMissing: true }
        );
        const hasKpiTrend =
          typeof card.percentageChange === "number" &&
          Number.isFinite(card.percentageChange);
        return (
        <div key={card.title} className="organic-content-card">
          <div className="organic-content-card__header">
            <div>
              {(() => {
                const definitionInfo = getOrganicContentKpiDefinitionInfo(
                  card.title,
                  card.tooltipLabel,
                  formatKpiTitle,
                  t,
                  "instagram",
                );
    
                return (
                  <div className="organic-content-card__title-row">
                    <h3>{formatKpiTitle(card.title, t)}</h3>
                    <DefinitionTooltip
                      label={formatKpiTitle(card.title, t)}
                      info={definitionInfo}
                      align={index >= 2 ? "end" : "start"}
                      formulaTitle={t("organicMedia.common.formula")}
                    />
                  </div>
                );
              })()}
              <div className="organic-content-card__value">{card.value}</div>
            </div>
            <div className="organic-content-card__icon" aria-hidden>
              {(() => {
                const key =
                  Object.keys(KPI_ICON_MAP).find(candidate =>
                    card.title.toLowerCase().includes(candidate)
                  ) ?? "posts";
                const Icon = KPI_ICON_MAP[key];
                return <Icon size={20} />;
              })()}
            </div>
          </div>
          <div className="organic-content-card__footer">
            {hasKpiTrend ? (
              <div className="organic-content-card__period">
                <span
                  className={`organic-content-card__change organic-content-card__change--${getTrendState(kpiTrendPct)}`}
                >
                  {kpiTrendPct === 0 ? null : kpiTrendPct > 0 ? (
                    <TrendingUp size={13} aria-hidden />
                  ) : (
                    <TrendingDown size={13} aria-hidden />
                  )}
                  {card.percentageChangeFormattedValue ??
                    withBidiIsolate(
                      `${formatNumber(kpiTrendPct, { minimumFractionDigits: 2, maximumFractionDigits: 2 }, i18n.language)}%`,
                      i18n.language
                    )}
                </span>
                <span>{card.comparisonLabel}</span>
              </div>
            ) : null}
          </div>
        </div>
      );
      })}
    </div>
  );
};

export default InstagramContentKpiCards;
